webpackJsonp([169503980156000],{

/***/ 829:
/***/ (function(module, exports) {

	module.exports = {"data":{"themenJson":{"thema":"London","monat_num":3,"thema_cover_uri":"03_2006.jpg","jahr":2006,"monat":"March","id":"thema_49","issue_date":"200603","moving_image_count":6,"still_image_count":4,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"thema_49"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200603-58595d9527968afe3a77.js